import { cn } from '@frontends/util-cn';
import { memo } from 'react';
import { Grid } from 'react-loader-spinner';

const Spinner = memo(function Spinner() {
  return (
    <div className={cn('flex justify-center items-center h-svh bg-transparent z-50')}>
      <Grid
        visible={true}
        height="45"
        width="45"
        color={'var(--brandPrimary)'}
        ariaLabel="grid-loading"
        radius="10"
        wrapperStyle={{}}
        wrapperClass="grid-wrapper"
      />
    </div>
  );
});
export default Spinner;
